import React from 'react'
import { colors } from './shibui';

export default {
  HeroSVG: ({ offset = '-6%'}) => (
    <svg
      width="4788"
      height="1921"
      style={{ transform: `translate(-18%, ${offset})`}}
      xmlns="http://www.w3.org/2000/svg">
      <defs>
        <path id="a-23i23" d="M3132 3471h1441v1664H3132z" />
        <linearGradient x1="100%" y1="86.413%" x2="0%" y2="100%" id="b-e9393">
          <stop stopColor="#362C4C" offset="0%" />
          <stop stopColor={colors.graphite.color} offset="100%" />
        </linearGradient>
        <linearGradient x1="297.88%" y1="56.579%" x2="32.238%" y2="89.451%" id="c-29292">
          <stop stopColor="#16181C" offset="0%" />
          <stop stopColor={colors.fuss50.color} offset="24.621%" />
          <stop stopColor="#222B39" offset="100%" />
        </linearGradient>
        <linearGradient x1="70.794%" y1="-11.368%" x2="14.819%" y2="85.258%" id="d-23i3223">
          <stop stopColor="#16181C" offset="0%" />
          <stop stopColor={colors.amethyst50.color} offset=".058%" />
          <stop stopColor="#222B39" offset="100%" />
        </linearGradient>
      </defs>
      <g transform="translate(-497 -2956)" fill="none" fillRule="evenodd">
        <use fillOpacity="0" href="#a-23i23" />
        <path d="M1678.757 152.65l2259.06 6.375c223.228.63 403.857 181.769 403.857 404.998v3892.632c0 223.676-181.325 405-405 405H1681.753c-223.508 0-404.763-181.063-405-404.57l-4.139-3899.006c-.237-223.675 180.895-405.192 404.57-405.43.524 0 1.048 0 1.573.002z" fill="url(#b-e9393)" transform="rotate(-60 2807.144 2507.152)" />
        <rect fill="url(#c-29292)" transform="rotate(-60 2865.33 2692.818)" x="1743.584" y="803.573" width="2243.491" height="3778.491" rx="307" />
        <rect fill="url(#d-23i3223)" transform="rotate(-60 3083.82 2814.996)" x="2283.574" y="1484.25" width="1600.491" height="2661.491" rx="240" />
      </g>
    </svg>
  )
}


// WEBPACK FOOTER //
// ./src/components/assets/herobg.js